import { Routes, Route } from 'react-router-dom'
import AppLayout from './components/AppLayout'
import HomePage from './pages/HomePage'
import DecksPage from './pages/DecksPage'
import StudyPage from './pages/StudyPage'
import SettingsPage from './pages/SettingsPage'
import GeneratePage from './pages/GeneratePage'
import AdminPage from './pages/AdminPage'
import OAuthCallbackPage from './pages/OAuthCallbackPage'
import { useTheme } from './hooks/useTheme'

function App() {
  useTheme()
  
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/decks" element={<DecksPage />} />
        <Route path="/study" element={<StudyPage />} />
        <Route path="/generate" element={<GeneratePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/auth/callback" element={<OAuthCallbackPage />} />
      </Routes>
    </AppLayout>
  )
}

export default App
